module.exports = __webpack_public_path__ + "static/media/surf-eka.0d80566a.png";